import { gql } from "@apollo/client";

const query = gql`
  query Query(
    $filterCompany: FilterFindManyEmailTemplateInput,
    $filterListing: FilterFindOneListingInput!,
    $filterCountApplicants: FilterCountTalentListingDistanceInput,
    $filterCountProspects: FilterCountTalentListingDistanceInput,
    $filterApplicants: FilterFindManyTalentListingDistanceInput,
    $filterProspects: FilterFindManyTalentListingDistanceInput,
    $skip: Int,
    $limit: Int,
    $sort: SortFindManyTalentListingDistanceInput
  ) {
    emailTemplateFindMany(filter: $filterCompany) {
      _id
      name
      subject
      content
    }
    listing: listingFindOne(
      filter: $filterListing
    ) {
      _id
      listingId
      createdDate
      name
      details
      settings {
        weights {
          function
          seniority
          industry
          autopilot
        }
        ceilings {
          function
          seniority
          industry
          autopilot
        }
        keywords {
          function
          skill
          seniority
          companyindustry
          companysize
        }
      }
      updatedDate
      prospectSummary
      applicantSummary
    }
    applicantsCount: talentListingDistanceCount(
      filter: $filterCountApplicants
    )
    prospectsCount: talentListingDistanceCount(
      filter: $filterCountProspects
    )
    applicants: talentListingDistanceMany(
      filter: $filterApplicants,
      limit: $limit,
      skip: $skip,
      sort: $sort
    ) {
      _id
      companyAlias
      listingId
      applicationId
      applicationDate
      name
      email
      context
      linkedinId
      details
      summary
      priority
      match
      talent {
        details
        companyAlias
        listingId
        candidateId
        listing {
          name
        }
      }
    }
    prospects: talentListingDistanceMany(
      filter: $filterProspects,
      limit: $limit,
      skip: $skip,
      sort: $sort
    ) {
      _id
      listingId
      applicationId
      applicationDate
      name
      email
      context
      linkedinId
      details
      summary
      priority
      match
      talent {
        details
        companyAlias
        listingId
        candidateId
        listing {
          name
        }
      }
    }
  }
`;

const updateContext = gql`
  mutation TalentListingDistanceUpdateOne(
    $filter: FilterUpdateOneTalentListingDistanceInput,
    $record: UpdateOneTalentListingDistanceInput!
  ) {
    talentListingDistanceUpdateOne(
      filter: $filter,
      record: $record
    ) {
      recordId
    }
  }
`;

export default {
  query,
  updateContext,
};
